<template>
<p class="edss-score"><span class="score">{{mapping[$store.state.year]}}</span><span>EDSS<br>Score</span></p>
</template>
<script>
export default {
  name: "EdssScore",
  data() {
    return {
      mapping: { // mapping of year to EDSS scale values
        0: 0,
        1: 2,
        2: 5.5,
        3: 2.5,
        4: 6.5,
        5: 3.5,
        6: 3.5,
        7: 6,
        8: 5,
        9: 5,
        10: 5,
        11: 6.5,
        12: 5.5,
        13: 6.0,
        14: 6.0,
        15: 6.5,
        16: 6.5,
        17: 6.5,
        18: 7,
        19: 7.5,
        20: 8
      }
    }
  }
}
</script>
<style lang="scss">
.edss-score {
  font-size: 2rem;
  margin-bottom: 0;
  line-height: 1;
  position: absolute;
  width: 300px;
  left: 125px;
  top: -55px;
  text-align: left;
  span {
    color: rgba(255,255,255,0.6);
    display: inline-block;
    vertical-align: middle;

    &.score {
      font-size: rem(95px);
      margin-right: 1rem;
      font-weight: $font-weight-bold;
    }
  }
}
</style>
